document.addEventListener("DOMContentLoaded", () => {
	const clickHandle = (event, tab) => {
		const currentTabContent = document.getElementById(tab);

		if (currentTabContent.classList.contains("active")) {
			return;
		}

		const currentActiveTabContent = document.querySelector(".recipe-details__tab-content.active");

		// Fade out the current active tab content
		if (currentActiveTabContent) {
			currentActiveTabContent.style.opacity = 0;
			currentActiveTabContent.classList.remove("active");
			setTimeout(() => {
				currentActiveTabContent.style.display = "none";
			}, 300);
		}

		// Fade in the new tab content
		currentTabContent.style.display = "block";
		setTimeout(() => {
			currentTabContent.style.opacity = 1;
			currentTabContent.classList.add("active");
		}, 0);
	};

	// Attach clickHandle to the click event of each tab link
	const tablinks = document.querySelectorAll(".recipe-details__tab-link");
	tablinks.forEach((link) =>
		link.addEventListener("click", (event) => {
			const tab = link.getAttribute("data-tab");
			clickHandle(event, tab);
		})
	);
});
